import { withAuth0 } from "@auth0/auth0-react";
import { Component } from "react";
import { connect } from "react-redux";
import CallCard from "../Components/CallCard/CallCard";
import ConversationWidget from "../Components/ConversationWidget/ConversationWidget";
import FilterBar from "../Components/FilterBar";
import {
    API_URL,
    CONNECTION_STATUS,
    WORKFLOW_FILTER,
    WS_URL,
    WORKDESK_CALL_NUMBER_LIMIT,
} from "../ConstVariable";
import "../index.css";
import LoaderThreeDot from "../Loader/LoaderThreeDot";
import OrderDetails from "../OrderDetails/OrderDetails";
import { SetError } from "../redux-store/actions";
import PaginationArrowBar from "../UI/PaginationArrowBar/PaginationArrowBar";
import axios from "axios";
import moment from "moment-timezone";
import SearchBar from "../Components/searchBar/SearchBar";
import {
    callRecordFunc,
    CenterCallStatusFunc,
    centerListCallHistoryFunc,
    centerListFunc,
    centerPreFixFunc,
    centerSelectFunc,
    clearConversationIdFunc,
    ClientMessageFunc,
    MobileNumberFunc,
    OperatorWatchListFun,
    setAssignedCenterList,
    SetSelectedWorkdeskConversation,
    setWebSocketConnectionStateFunc,
    setWilltryToConnectWebSocketFunc,
    StatusCode,
    statusListCallHistoryFunc,
    statusListFunc,
    UpdateConversationLog,
} from "../redux-store/actions";

import Template from "../UI/GridTemplate/Template";

class Workdesk extends Component {
    constructor(props) {
        super();
        
        this.user = props.auth0.user;
        // NOTE:- this a local state of workdesk component
        this.state = {
            unconcluded_calls: [],
            Loading: false,
            ApiError:false,
            endpoint: WS_URL,
            config_workflow_filter: WORKFLOW_FILTER,
            message: [],
            convmsg: [],
            conversationID: "",
            fetchedOrder: {},
            showAudio: false,
            NotShowLiveAudio: false,
            activeChatIndex: -1,
            showReferral: false,
            CallStatusRunningCall: "",
            ReferralData: "",
            ConversationObj: "",
            ReferralFormId: "",
            IsReferral: false,
            fromDate: "",
            toDate: "",
            callStatus: "",
            callerId: "",
            callStatusFilter: "COMPLETED CALLS",
            ConversationSearch: "",
            SearchClicked: false,
            showTestStatus: false,
            CallCenter: "",
            callStatusList: [],
            centerListArr: [],
            center_list: "",
            call_status_list: "",
            noDataState: false,
            SearchData: null,
            Netconnection: null,
            operatorwatchlist: null,
            showCenterList: [],
            callSourceList: [],
            gotNoOfCalls: 0,
            totalNumberOfCall: 0,
            firstName: "",
            lastName: "",
            dob: "",
            page_no: 0,
            areWeInSearchMode: false,
            date_search_by: "CALL_DATE"
        };
        this.clientSideMessage = null;
    }
    

    //This function will decide that which call needs to be shown on the UI based on the config_workflow_filter
    callFilteringFunc = (workflowType_received_from_backend) => {
        if (
            workflowType_received_from_backend === "" &&
            this.state.config_workflow_filter.length !== 0
        )
            return false;
        else if (this.state.config_workflow_filter.length === 0) return true;
        else if (
            this.state.config_workflow_filter === workflowType_received_from_backend
        )
            return true;
        else return false;
    };
    webSocketOnMessageHandler = (in_data) => {
        const jsonMsg = JSON.parse(in_data);
        const { conversation_id } = jsonMsg;
        const selectedConversationId = this.props.selectedConversationId;

        if (jsonMsg.event_type === "PING") {
            console.log("Connection is alive.");
            return;
        }

        const mapCall = (transform) => (calls) =>
            calls.map((call) =>
                call.conversation_id === conversation_id ? transform(call) : call
            );

        switch (jsonMsg.event_type) {
            case "RECORDING_AVAILABLE":
                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        is_recording_available: true,
                    }))
                );
                break;
            case "CALL_DISCONNECTED": {
                const extraState =
                    selectedConversationId === conversation_id &&
                    this.state.callStatusFilter === "LIVE CALLS"
                        ? { fetchedOrder: jsonMsg }
                        : {};

                if (extraState.fetchedOrder) {
                    this.props.clearConversationIdFromRedux();
                }

                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        call_status: jsonMsg.call_status,
                        appointment_to_be_booked_manually:
                            jsonMsg.appointment_to_be_booked_manually,
                        call_closed_at_last_state: jsonMsg.call_closed_at_last_state,
                    })),
                    extraState
                );
                break;
            }
            case "CALL_DISCONNECT":
                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        call_status: jsonMsg.call_status,
                    }))
                );
                break;
            case "NEW_CALL":
            case "CALL_MARKED_UNCONCLUDED":
                if (this.state.SearchClicked === true) {
                    this.props.increment_number_of_new_calls_since_last_search();
                    console.log(
                        "User has set a search filter. Dropping NEW CALL message."
                    );
                    return;
                }
                this.updateUnconcludedCalls((calls) => {
                    const withoutCurrent = calls.filter(
                        (call) => call.conversation_id !== conversation_id
                    );
                    return [jsonMsg, ...withoutCurrent];
                });
                this.props.MobileNumberFunc("");
                break;
            case "CONVERSATION_DETAILS":
                if (conversation_id === selectedConversationId) {
                    this.props.UpdateConversationLogs(jsonMsg.details);
                }
                break;
            case "ORDER_DETAILS":
                if (conversation_id === selectedConversationId) {
                    this.setState({ fetchedOrder: jsonMsg });
                }
                break;
            case "REFERRAL_PRESENT":
                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        referral_form_status: "Available",
                    }))
                );
                if (conversation_id === selectedConversationId) {
                    this.props.SetSelectedWorkdeskConversation({
                        conversation_id,
                        referral_form_status: "Available",
                    });
                }
                break;
            case "REFERRAL_PENDING": {
                const nickName = this.props.operator_name
                    .substring(0, 3)
                    .toUpperCase();
                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        referral_form_status: "Pending",
                        operator_feedback: jsonMsg.operator_feedback,
                        operator_name: this.props.operator_name,
                        operator_nickname: nickName,
                    }))
                );
                if (conversation_id === selectedConversationId) {
                    this.props.SetSelectedWorkdeskConversation({
                        conversation_id,
                        referral_form_status: "Pending",
                    });
                }
                break;
            }
            case "DEMOGRAPHICS_PENDING":
                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        demographic_status: "DEMOGRAPHICS_PENDING",
                    }))
                );
                if (conversation_id === selectedConversationId) {
                    this.props.SetSelectedWorkdeskConversation({
                        conversation_id,
                        referral_form_status: "None",
                    });
                }
                break;
            case "DEMOGRAPHICS_AVAILABLE":
                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        demographic_status: "DEMOGRAPHICS_AVAILABLE",
                    }))
                );
                if (conversation_id === selectedConversationId) {
                    this.props.SetSelectedWorkdeskConversation({
                        conversation_id,
                        referral_form_status: "None",
                    });
                }
                break;
            case "REFERRAL_RE_REQUEST":
                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        referral_form_status: "Referral_re_request",
                    }))
                );
                if (conversation_id === selectedConversationId) {
                    this.props.SetSelectedWorkdeskConversation({
                        conversation_id,
                        referral_form_status: "Referral_re_request",
                    });
                }
                break;
            case "REFERRAL_REQ_COUNTER":
                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        referral_form_request_counter:
                            jsonMsg.referral_form_request_counter,
                    }))
                );
                break;
            case "CALL_ESCALATION":
                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        Call_escalate: "Escalate",
                    }))
                );
                break;
            case "CALL_MARKED_CONCLUDED":
                if (conversation_id === selectedConversationId) {
                    this.props.SetSelectedWorkdeskConversation({
                        conversation_id: null,
                        referral_form_status: null,
                    });
                }
                this.updateUnconcludedCalls((calls) =>
                    calls.filter((call) => call.conversation_id !== conversation_id)
                );
                break;
            case "OPERATOR_WATCHLIST":
                if (jsonMsg.watch_list.length !== 0) {
                    this.props.setOperatorWatchListFun({
                        conversation_id,
                        watch_list: jsonMsg.watch_list,
                    });
                }
                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        watch_list: jsonMsg.watch_list,
                    }))
                );
                break;
            case "MOBILE_NUMBER_CONFIRMED":
                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        caller_id: jsonMsg.mobile_number,
                        updated_mob_number: jsonMsg.mobile_number,
                    }))
                );
                this.props.MobileNumberFunc(jsonMsg.mobile_number);
                break;
            case "CENTER_ID_CONFIRMED":
                this.updateUnconcludedCalls(
                    mapCall((call) => ({
                        ...call,
                        center_prefix: jsonMsg.center_prefix,
                        center_name: jsonMsg.center_name,
                    }))
                );
                this.props.centerPreFixFunc(jsonMsg.center_prefix);
                this.props.centerSelectFunc(jsonMsg.center_name);
                break;
            default:
                break;
        }
    };

    componentWillUnmount = () => {
        // console.error("Component unmounted!!!");

        if (this.props.web_socket) {
            this.props.web_socket.webSocketOnMessageCallBack = null;
        }
    };
    // NOTE:- This componentDidMountWithToken function runs when component mount
    // This function contain with WebSocket connection and it's all event  . all the event comes through this function
    componentDidMountWithToken = async () => {
        // Sending the operator info whenever he select the call
        this.clientSideMessage = ({
            conversation_id,
            operator_id,
            event,
        }) => {
            var msg = {
                conversation_id: conversation_id,
                operator_id: operator_id,
                event: event,
            };

            // We will not send message if WebSocket is not in CONNECTED State
            if (this.props.ws_connection_status === CONNECTION_STATUS.CONNECTED) {
                this.props.web_socket.socket.send(JSON.stringify(msg));
            }
        };
    };

    // NOTE:- This GetAuthToken function return the token
    GetAuthToken = async () => {
        const { getAccessTokenSilently } = this.props.auth0;
        const token = await getAccessTokenSilently();
        return token;
    };
    
    GetUser = async () => {
        const { user } = this.props.auth0;
        return user;
    };

    

    // NOTE:-This Get unconcluded call list function runs when page mount
    refreshCallList = async (
        applyFilter = false,
        page_no = 0,
        areWeInSearchMode = this.state.areWeInSearchMode
    ) => {
        console.log(
            "Fetching unconcluded call-list. param:applyFilter=" + applyFilter
        );

        // let centerList =[]
        // if(this.state.center_list){
        //     centerList=this.state.center_list.map((item)=> Number(item.center_id))
        //     console.log("centerList",centerList)
        // }
        var request_data = { conversationWorkflow: "" };

        if (applyFilter === true || areWeInSearchMode) {
            if (this.state.fromDate !== "" && this.state.toDate !== "") {
                let CheckfromDate = new Date(this.state.fromDate);
                let ChecktoDate = new Date(this.state.toDate);

                if (CheckfromDate.getTime() <= ChecktoDate.getTime()) {
                    // console.log("Correct Date range");
                } else {
                    // console.log("Wrong Date");
                    this.props.SetErrorForDisplay({
                        severity: "warning",
                        message: "Your from date can not be greater than current date",
                    });
                    return;
                }
            }
            if (this.state.fromDate !== "" && this.state.toDate === "") {
                this.props.SetErrorForDisplay({
                    severity: "warning",
                    message: "Please select To date",
                });
                return;
            }
            if (this.state.fromDate === "" && this.state.toDate !== "") {
                this.props.SetErrorForDisplay({
                    severity: "warning",
                    message: "Please select From date",
                });
                return;
            }

            request_data.end_date = this.state.toDate;
            request_data.status = "";
            request_data.conversation_id = this.state.ConversationSearch;
            request_data.caller_id = this.state.callerId;
            request_data.center_id = this.state.CallCenter
                ? this.state.CallCenter
                : [];
            request_data.operator_feedback = this.state.callStatusList
                ? this.state.callStatusList
                : [];
            request_data.initiator_source = this.state.callSourceList;
            request_data.start_date = this.state.fromDate;
            request_data.last_name = this.state.lastName;
            request_data.dob = this.state.dob;
            request_data.first_name = this.state.firstName;
            request_data.date_search_by = this.state.date_search_by
            request_data.call_context = this.state.call_context ;
            request_data.current_call_status=this.state.callStatusFilter;

            if (this.state.dob) {
                // console.log("DOB", this.state.dob )
                // let DOB  = this.state.dob.split("/").reverse().join("-");
                // console.log("DOB", new Date(this.state.dob))
                request_data.dob = moment(this.state.dob).format("YYYY-MM-DD");
            }
        }

        const token = await this.GetAuthToken();
        

        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Accept", "application/json");
        myHeaders.append("Authorization", `Bearer ${token}`);
        this.setState({ Loading: true, gotNoOfCalls: 0, ApiError:false });

        // NOTE:- This API fetchs the all unconcluded_calls list data and we store it into local state unconcluded_calls

        axios({
            method: "post",
            url: `${API_URL}/oi/api/v1/unconcluded-calls?page_no=${page_no}`,
            data: request_data,
            headers: {
                Accept: "application/json",
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            withCredentials: true
        })
            .then((response) => {
                let headers_data = response.headers;

                this.setState({
                    unconcluded_calls: [...response.data],
                    Loading: false,
                    ApiError:false,
                    totalNumberOfCall: headers_data["x-count"],
                    gotNoOfCalls: response.data.length,
                });
            })
            .catch((error) => {
                this.props.SetErrorForDisplay({
                    severity: "warning",
                    message: error.message,
                });
                this.setState({ Loading: false, ApiError:true });
            });
    };

    //We are checking the intenet connection in previous State and the current state
    // if previous state if true and current state is false then we are fetching the call list
    componentDidUpdate(prevProps, prevState) {
        //When the details update to the redux then we are getting the data of center list

        if (
            prevProps.operatorAssignedCenters.length === 0 &&
            this.props.operatorAssignedCenters.length > 0
        ) {
            this.setState({
                center_list: this.props.operatorAssignedCenters,
            });
        }

        // Websocket reconnection happened...
        if (
            prevProps.web_socket === null &&
            this.props.web_socket != null &&
            this.props.ws_connection_status === CONNECTION_STATUS.CONNECTED
        ) {
            console.log("Subcsribing to OnMessage hdlr on reconnection...");
            this.websocket_on_message_handler();

            this.setState({
                page_no: 0,
                unconcluded_calls: [],
            });
            // if (this.state.SearchClicked === false)
            this.refreshCallList();
        }
    }

    fetchFilteredResults() {
        return (
            this.state.fromDate ||
            this.state.toDate ||
            this.state.callStatus ||
            this.state.ConversationSearch ||
            this.state.callerId ||
            this.state.centerListArr ||
            this.props.CallStatusCallHistoryList ||
            this.state.callSourceList
        );
    }
    websocket_on_message_handler() {
        this.props.web_socket.webSocketOnMessageCallBack =
            this.webSocketOnMessageHandler;
    }

    // this function runs as soon as  component mount
    componentWillMount() {
        if (this.props.ws_connection_status === CONNECTION_STATUS.CONNECTED) {
            this.props.reset_number_of_new_calls_since_last_search();

            // commenting out refresh call list on component moount as it is being called from SearchBar component also.
            //this.refreshCallList(false, this.state.page_no);
        } else {
            this.setState({ Loading: true, ApiError:false });
        }
    } //end life cycle

    // NOTE:- scrollToBottom function runs the scroll of chat from top to bottom
    scrollToBottom = () => {
        if (this.container) {
            this.container.scrollTop = this.container.scrollHeight;
        }
    };
    passShowRecordsStatus = (color, conversationID) => {
        return color ? true : false;
    };

    showReferralChatWindowFunc = () => {
        this.setState({ showReferralChatWindow: true });
    };
    showChatWindowFunc = () => {
        this.setState({ showReferralChatWindow: false });
    };

    ReferralHandler = (check) => {
        this.setState({
            showReferral: check,
        });
    };

    IsReferralForm = (data) => {
        this.setState({ IsReferral: data });
    };

    // NOTE:- This function is for Search Bar
    InputHandler = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });
    };

    callSourceListHandler = (list) => {
        this.setState({
            callSourceList: list,
        });
    };

    // NOTE:- to reset the search input from search bar
    ResetHandler = () => {
        this.setState({
            fromDate: "",
            toDate: "",
            ConversationSearch: "",
            callStatus: "",
            callerId: "",
            CallCenter: "",
            SearchClicked: false,
            callStatusList: [],
            centerListArr: [],
            SearchData: null,
            callSourceList: [],
            lastName: "",
            dob: "",
            firstName: "",
            areWeInSearchMode: false,
            page_no: 0,
            unconcluded_calls: [],
            date_search_by: "CALL_DATE",
        });

        // NOTE:- this centerListFunc and   statusListFunc   are stored in redux store now on reset we make null to these state of redux
        this.props.centerListFunc(null);
        this.props.statusListFunc(null);
        // this.refreshCallList(false, 0, false);
        this.props.reset_number_of_new_calls_since_last_search();
        this.props.centerListCallHistoryFunc(null);
    };

    // NOTE:- callStatusCodeListHandler function handle the check box modal input of call Status and stote the input in callStatusLis local state

    // NOTE :- This componentDidMount function runs when the workdesk page render and runs the all function which are contain to this
    componentDidMount() {
        // When the component mount the we are getting the center list from the redux
        this.setState({
            center_list: this.props.operatorAssignedCenters.map((item) => {
                return { ...item, isChecked: false };
            }),
        });

        this.componentDidMountWithToken();

        this.props.callRecordFunc(null);
        //NOTE:- this.props.auth0  returns the user details
        const { user } = this.props.auth0;
        // console.log("USER NAME ", user);

        //NOTE:- OperatorDetails function send the User details to remove userdetails from watch list when this page mount

        this.operatorDetails(user.email);
        //NOTE:- CenetrAndCallStatus func. gets the all list of center and CallStatus list
        //NOTE:- centerListFunc reset null to workdesk centerlist checkbox into redux when page mount
        this.props.centerListFunc(null);
        //NOTE:- statusListFunc reset null to workdesk statuslist checkbox into redux when page mount
        this.props.statusListFunc(null);
        this.props.statusListCallHistoryFunc([]);
        this.props.centerListCallHistoryFunc(null);

        // Websocket was already connected but user switched PAGES.
        if (this.props.web_socket) {
            console.log(
                "User switched pages. Subcsribing to OnMessage hdlr on reconnection"
            );
            this.websocket_on_message_handler();
        }
    }

    //  NOTE:-CenetrAndCallStatus function fetch the all data of center list and call status list
    // NOTE:- stores call status list and center list into local state call_status_list ,center_list

    //NOTE:- This operatorDetails function takes the UserEmail and send UserEmail to backend
    operatorDetails = (Useremail) => {
        var myHeaders = new Headers();
        myHeaders.append("Content-Type", "application/json");
        myHeaders.append("Accept", "application/json");

        let data = {
            operator_id: Useremail,
            event: "LOGOUT_OPERATOR",
        };
        var raw;
        raw = JSON.stringify(data);

        var requestOptions = {
            method: "POST",

            headers: myHeaders,
            body: raw,
            redirect: "follow",
            credentials: "include"
        };
        fetch(`${API_URL}/oi/api/v1/watch-list`, requestOptions)
            .then((response) => response.json())
            .then((data) => {
                // console.log("search DATA", data);
                // setCurrentOperator(data);
                // console.log("User Refreshed Data...", data);
            })
            .catch((error) => {
                // this.props.SetErrorForDisplay({
                //   severity: "warning",
                //   message: error.message,
                // });
            });
    };

    nextCallHandler = () => {
        const { firstNoOfCalls, secondNoOfcalls } = this.getNoOfCallsRange();

        if (parseInt(secondNoOfcalls) === parseInt(this.state.totalNumberOfCall))
            return;

        this.setState({
            unconcluded_calls: [],
            page_no: this.state.page_no + 1,
        });
        this.refreshCallList(false, this.state.page_no + 1);
        this.props.clearConversationIdFromRedux();
    };

    previousCallHandler = () => {
        if (!this.state.page_no) return;
        // console.log("this.state.page_no-1",this.state.page_no, parseInt(this.state.page_no)-1)
        this.refreshCallList(false, parseInt(this.state.page_no) - 1);

        this.setState({
            page_no: this.state.page_no - 1,
            unconcluded_calls: [],
        });

        this.props.clearConversationIdFromRedux();
    };

    getNoOfCallsRange = () => {
        let totalNumberOfCall = this.state.totalNumberOfCall;
        let firstNoOfCalls = WORKDESK_CALL_NUMBER_LIMIT * this.state.page_no;
        let secondNoOfcalls;
        //At the end of page
        if (totalNumberOfCall - firstNoOfCalls <= WORKDESK_CALL_NUMBER_LIMIT) {
            secondNoOfcalls = firstNoOfCalls + (totalNumberOfCall - firstNoOfCalls);
        } else {
            secondNoOfcalls = firstNoOfCalls + WORKDESK_CALL_NUMBER_LIMIT;
        }

        //Initial Call list
        if (!this.state.page_no) {
            let firstNoOfCalls = 0;
            if (this.state.callStatusFilter === "COMPLETED CALLS") {
                firstNoOfCalls = this.state.unconcluded_calls?.filter(
                    (el) => el.call_status !== "IN_PROGRESS"
                ).length || 0;
            } else {
                firstNoOfCalls = this.state.unconcluded_calls?.length || 0;
            }

            return {
                firstNoOfCalls,
                secondNoOfCalls: 0,
            };
        }

        return { firstNoOfCalls: firstNoOfCalls, secondNoOfcalls: secondNoOfcalls };
    };

    getFilteredCalls = () => {
        const { unconcluded_calls, callStatusFilter } = this.state;
        if (!Array.isArray(unconcluded_calls)) {
            return [];
        }
        if (callStatusFilter === "LIVE CALLS") {
            return unconcluded_calls.filter(
                (call) => call.call_status === "IN_PROGRESS"
            );
        }
        if (callStatusFilter === "COMPLETED CALLS") {
            return unconcluded_calls.filter(
                (call) => call.call_status !== "IN_PROGRESS"
            );
        }
        return unconcluded_calls;
    };

    updateUnconcludedCalls = (updater, extraState = {}) => {
        this.setState((prevState) => {
            const previousCalls = Array.isArray(prevState.unconcluded_calls)
                ? prevState.unconcluded_calls
                : [];
            const nextCalls = updater(previousCalls);
            return {
                unconcluded_calls: nextCalls,
                ...extraState,
            };
        });
    };

    searchHandler = (searchData) => {
        this.setState({
            SearchClicked: true,
            unconcluded_calls: [],
            areWeInSearchMode: true,
            gotNoOfCalls: 0,
            page_no: 0,
            Loading: true,
            ApiError:false,
            fromDate: searchData?.start_date,
            toDate: searchData?.end_date,
            ConversationSearch: "",
            callStatusList: searchData?.operator_feedback,
            callerId: searchData?.caller_id,
            CallCenter: searchData?.center_id,
            callSourceList: searchData?.initiator_source,
            lastName: searchData?.last_name,
            dob: searchData?.dob,
            firstName: searchData?.first_name,
            date_search_by: searchData?.date_search_by,
            call_context:searchData?.call_context
        });
    };

    render() {
        //   NOTE:- thsi showcallRecords stores the callCard data
        let showcallRecords = null;
        const filteredCalls = this.getFilteredCalls();

        if (this.state.Loading) {
            showcallRecords = (
                <div
                    className="text-center"
                    style={{
                        marginTop: "45vh",
                    }}
                >
                    <LoaderThreeDot />
                </div>
            );
        } else {
            showcallRecords = (
                <ul
                    className=" nav flex-column"
                    style={{
                        flex: 1,
                        scrollSnapType: "y mandatory",
                        textDecoration: "none",
                        listStyle: "none",
                        padding: "0px",
                    }}
                >

                    {Array.isArray(filteredCalls) && filteredCalls.length === 0 && this.state.callStatusFilter == 'ALL CALLS' &&
                    !this.state.ApiError   &&    <div
                            style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginTop: "2vh",
                                marginLeft: "2vh",
                            }}
                        >
                            <p> No Unconcluded calls present.</p>{" "}
                        </div>
                    }

                    {Array.isArray(filteredCalls) && filteredCalls.length === 0 && this.state.callStatusFilter == 'LIVE CALLS' &&
                    !this.state.ApiError   &&     <div
                            style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginTop: "2vh",
                                marginLeft: "2vh",
                            }}
                        >
                            <p> No Live calls present.</p>{" "}
                        </div>
                    }

                    {Array.isArray(filteredCalls) && filteredCalls.length === 0 && this.state.callStatusFilter == 'COMPLETED CALLS' &&
                    !this.state.ApiError   &&     <div
                            style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginTop: "2vh",
                                marginLeft: "2vh",
                            }}
                        >
                            <p> No Completed calls present.</p>{" "}
                        </div>
                    }
                    {Array.isArray(filteredCalls) && filteredCalls.length === 0 &&
                    this.state.ApiError   &&  <div
                            style={{
                                fontWeight: "bold",
                                fontSize: "16px",
                                marginTop: "40vh",
                                marginLeft: "2vh",
                            }}
                        >
                           <p>There is a network problem with your connection. </p> <p> Please check your internet connection and try again later.</p>
                        </div>
                    }

                    {Array.isArray(filteredCalls) && filteredCalls.length > 0 &&
                        filteredCalls.map((k, index) => (
                            <CallCard
                                key={index}
                                center_id={k?.center_id}
                                conversation_id={k.conversation_id}
                                caller_id={k.caller_id}
                                mobile_number={k.mobile_number}
                                updated_mob_number={k.updated_mob_number}
                                center_prefix={k.center_prefix}
                                center_name={k.center_name}
                                initiate_time={k.initiate_time}
                                creation_date_at_center={k.creation_date_at_center}
                                call_status={k.call_status}
                                call_closed_at_last_state={k.call_closed_at_last_state}
                                status_code={k.operator_feedback}
                                referral_form_status={k.referral_form_status}
                                Call_escalate={k.Call_escalate}
                                referral_counter={k.referral_form_request_counter}
                                operator_name={k.operator_name}
                                operator_nickname={k.operator_nickname}
                                oerderSaved={this.state.showTestStatus}
                                watch_list={k.watch_list}
                                initiator_source={k.initiator_source}
                                clientSideMessage={this.clientSideMessage}
                                // updatedDataSend={this.updatedDataSend}
                                demographic_status={k.demographic_status}
                                bot_error={k.bot_error}
                                appointment_to_be_booked_manually={
                                    k.appointment_to_be_booked_manually
                                }
                                bp_appointment_id={k.bp_appointment_id}
                                is_recording_available={k.is_recording_available}
                                ereferral_uid={k.ereferral_uid}
                                language_code={k.language_code}
                                callStatusFilter={this.state.callStatusFilter}
                                webbot_conversation_device={k.webbot_conversation_device}
                                center_timezone={k.center_timezone}
                                server_timezone={k.server_timezone}
                                operator_feedback={k.operator_feedback}
                                conversation_context={k.conversation_context}
                                client_ip={k?.client_ip}
                            />
                        ))}{" "}
                </ul>
            );
        }

        // console.log("FilteredCall", this.state.FilteredCall);
        // console.log("CenterList******", this.state.centerListArr);

        const noOfCalls = () => {
            const { firstNoOfCalls, secondNoOfcalls } = this.getNoOfCallsRange();
            if (!secondNoOfcalls) {
                return `1-${firstNoOfCalls}`;
            } else {
                return `${firstNoOfCalls + 1}-${secondNoOfcalls}`;
            }
        };

        return (
            <Template>
                <SearchBar
                    callDataHandler={(data) => {
                        this.setState({
                            unconcluded_calls: [...data?.data],
                            gotNoOfCalls: data?.data.length,
                            totalNumberOfCall: data?.totalCallCount,
                            SearchClicked: false,
                            Loading: false,
                            ApiError:false,
                            callStatusFilter: data?.callStatusFilter
                        });
                    }}
                    errorDataHandler={()=>{
                        this.setState({
                            Loading: false,
                            ApiError:true
                        });
                    }}
                    gotNoOfCalls={this.state.gotNoOfCalls}
                    totalNumberOfCall={this.state.totalNumberOfCall}
                    noOfCallsText={noOfCalls}
                    componentIdentity="workdesk"
                    onSearchClick={(searchData) => {
                        this.searchHandler(searchData);
                    }}
                    onResetClick={this.ResetHandler}
                    page_no={0}
                />

                <div>
                    <div> {showcallRecords} </div>
                    {this.state?.totalNumberOfCall > 50 && (
                        <PaginationArrowBar
                            page_no={this.state.page_no}
                            nextButton={this.nextCallHandler}
                            previousButton={this.previousCallHandler}
                            getNoOfCallsRange={this.getNoOfCallsRange}
                            totalNumberOfCall={this.state.totalNumberOfCall}
                        ></PaginationArrowBar>
                    )}
                </div>

                <ConversationWidget

                // NOTE:- this function send the info to WebSocket about user
                // clientSideMessage={(data) =>
                //   this.state.clientSideMessage(data)
                // }
                ></ConversationWidget>

                {<OrderDetails
                    recordsLoading={this.state.Loading}
                    getTokenFunc={this.GetAuthToken}
                    fetchedLiveOrder={this.state.fetchedOrder}
                    showtestcallfunc={(val) =>
                        this.setState({ showTestStatus: val })
                    }
                    onSaveFetchingAllCallList={this.refreshCallList}
                />}
            </Template>
        );
    }
}

// NOTE:- this mapStateToProps function returns the state of redux store
const mapStateToProps = (state) => {
    return {
        selectedConversationId: state.SelectedConversationId,
        ReferralFormPresent: state.ReferralFormPresent,
        errorForDisplay: state.Error,
        operator_name: state.operatorName,
        operatorEmail: state.operatorEmail,
        CallStatusCallHistoryList: state.CallStatusCallHistoryList,
        WebSocketConnectionState: state.WebSocketConnectionState,
        isInternetDisconnected: state.isInternetDisconnected,
        willTryToReconnectWebSocketInSec: state.willTryToReconnectWebSocketInSec,
        operatorAssignedCenters: state.operatorAssignedCenters,
        selectedCenterIds: state.CenterListCallHistory,
    };
};

//NOTE:- mapDispatchToProps function returns the function to dispatch the data to redux store
const mapDispatchToProps = (dispatch) => {
    return {
        SetSelectedWorkdeskConversation: (val) =>
            dispatch(SetSelectedWorkdeskConversation(val)),
        UpdateConversationLogs: (val) => dispatch(UpdateConversationLog(val)),
        SetErrorForDisplay: (payload) => dispatch(SetError(payload)),
        setStatusCode: (code) => dispatch(StatusCode(code)),
        setclientMessageFunc: (val) => dispatch(ClientMessageFunc(val)),

        setOperatorWatchListFun: (data) => dispatch(OperatorWatchListFun(data)),
        CenterCallStatusFunc: (data) => dispatch(CenterCallStatusFunc(data)),
        centerListFunc: (data) => dispatch(centerListFunc(data)),
        statusListFunc: (data) => dispatch(statusListFunc(data)),
        callRecordFunc: (data) => dispatch(callRecordFunc(data)),
        centerSelectFunc: (data) => dispatch(centerSelectFunc(data)),
        centerPreFixFunc: (data) => dispatch(centerPreFixFunc(data)),
        statusListCallHistoryFunc: (data) =>
            dispatch(statusListCallHistoryFunc(data)),
        centerListCallHistoryFunc: (data) =>
            dispatch(centerListCallHistoryFunc(data)),
        MobileNumberFunc: (mobile_number) =>
            dispatch(MobileNumberFunc(mobile_number)),
        setAssignedCenterList: (centers) =>
            dispatch(setAssignedCenterList(centers)),
        setWebSocketConnectionStateFunc: (readyState) =>
            dispatch(setWebSocketConnectionStateFunc(readyState)),
        setWilltryToConnectWebSocketFunc: (sec) =>
            dispatch(setWilltryToConnectWebSocketFunc(sec)),
        clearConversationIdFromRedux: (data) => dispatch(clearConversationIdFunc()),
    };
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withAuth0(Workdesk));
